import generateRandomString from '../MSRP/utilities/generators';

// TODO: WHY DO'NT WE USE REDUX?
class Global {
  static username: string;
  static displayname: string;
  static companyDomain: string;
  static sessionId: string = getSessionIdentifier();
  static counter = 0;
  static serviceIP: string = 'https://rtc.icont.ai';

}

function getSessionIdentifier(): string {
  let randomValue = sessionStorage.getItem("sessionRandomValue");
  let counter = sessionStorage.getItem("sessionCounter");
  console.log("session counter", counter);

  if (!randomValue) {
    randomValue = generateRandomString(16);
    counter = "0";
  }
  console.log("session counter", counter);
  const sessionIdentifier = randomValue.toString() + counter?.toString();
  const nextCounter = parseInt(counter || "0", 10) + 1;
  sessionStorage.setItem("sessionRandomValue", randomValue);
  sessionStorage.setItem("sessionCounter", nextCounter.toString());

  return sessionIdentifier;
}


export default Global;
